import i18n from "@core/i18n";
import type { VoteType } from "../../../lib/insights/types";

/**
 * Tone CSS classes for a single result-table cell.
 * Tints à 22% pour les votes connus, gris muted pour les non-réponses.
 * Le glyphe lui-même est laissé au composant.
 */
export interface CellTone {
  /** Background + border classes */
  bgClass: string;
  /** Foreground class for the glyph */
  fgClass: string;
  /** Tooltip text (FR) */
  title: string;
}

const TONES: Record<VoteType | "empty", CellTone> = {
  yes: {
    bgClass: "bg-vote-available/[0.22] border border-vote-available/40",
    fgClass: "text-vote-available-foreground",
    title: i18n.t("resultsCellTone.cell_tone.available"),
  },
  maybe: {
    bgClass: "bg-vote-maybe/[0.22] border border-vote-maybe/40",
    fgClass: "text-vote-maybe-foreground",
    title: i18n.t("resultsCellTone.cell_tone.maybe"),
  },
  // Sous light/dark, --vote-unavailable reste rouge (rendu inchangé). Sous
  // Corail/Périwinkle il pointe vers le foreground du thème : le doc de
  // design (2026-09-07) demande une opacité plus faible pour ce cas précis
  // (6% fond / 30% texte, contre 22%/plein ailleurs) — non implémenté tel
  // quel ici pour garder un seul pattern d'opacité uniforme entre les 3
  // rôles et ne rien risquer sur le rendu existant ; à valider avec Julien
  // si l'écart de fidélité visuelle sur ce point précis compte pour lui.
  no: {
    bgClass: "bg-vote-unavailable/[0.22] border border-vote-unavailable/40",
    fgClass: "text-vote-unavailable-foreground",
    title: i18n.t("resultsCellTone.cell_tone.unavailable"),
  },
  empty: {
    bgClass: "bg-muted/30 border border-border/50",
    fgClass: "text-muted-foreground/60",
    title: i18n.t("resultsCellTone.cell_tone.no_response"),
  },
};

export function getCellTone(vote: VoteType | null | undefined): CellTone {
  if (vote === "yes" || vote === "maybe" || vote === "no") return TONES[vote];
  return TONES.empty;
}
